<section class="user-metadata">
  <div *ngIf="!displays.length">Loading...</div>
  <section class="token-container" *ngFor="let display of displays">
    <div class="header">{{ display.header }}</div>
    <span>
      <label [for]="display.tokenStr.slice(0, 6)">Copy to clipboard.</label>
      <button (click)="copyText(display)" [id]="display.tokenStr.slice(0, 6)">
        <!-- TODO: Remove this SVG if we decide to couple angular material to auth.
        -->
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="none" d="M0 0h24v24H0z"/>
          <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4l6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7zm-1 7h5.5L14 6.5V12z"/>
        </svg>
      </button>
      <span class="confirmation-msg" *ngIf="display.isCopied">Copied!</span>
    </span>
    <div class="tokenString">
      <pre>{{ display.tokenStr }}</pre>
    </div>
  </section>
</section>
